/* eslint-disable jsx-a11y/no-static-element-interactions */
import classNames from 'classnames';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PinchZoom, { make3dTransformValue } from 'react-quick-pinch-zoom';
let zoomTimerId;
let touchstartX = 0;
let touchendX = 0;
const CuratorCarouselSlideZoomModal = (props) => {
    const { t } = useTranslation();
    const zoomRef = useRef();
    const imgRef = useRef();
    const [isDragging, setIsDragging] = useState(false);
    const [zoomPos, setZoomPos] = useState({
        x: 0,
        y: 0,
        scale: 1,
    });
    const onUpdate = useCallback(({ x, y, scale }) => {
        const { current: img } = imgRef;
        if (img) {
            clearTimeout(zoomTimerId);
            zoomTimerId = setTimeout(() => {
                setZoomPos({ x, y, scale });
            }, 100);
            const value = make3dTransformValue({ x, y, scale });
            img.style.setProperty('transform', value);
        }
    }, []);
    const zoomOut = () => {
        zoomRef === null || zoomRef === void 0 ? void 0 : zoomRef.current.scaleTo({
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
            scale: zoomPos.scale - 1,
        });
    };
    const zoomIn = () => {
        zoomRef === null || zoomRef === void 0 ? void 0 : zoomRef.current.scaleTo({
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
            scale: zoomPos.scale + 1,
        });
    };
    useEffect(() => {
        props.onZoom(zoomPos.scale > 1);
    }, [zoomPos.scale]);
    return (React.createElement("div", { onKeyDown: (e) => {
            if (e.key == 'Escape') {
                props.onCloseModal();
            }
        }, onTouchStart: (e) => { var _a, _b; return (touchstartX = (_b = (_a = e.changedTouches) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.screenX); }, onTouchEnd: (e) => {
            var _a, _b;
            touchendX = (_b = (_a = e.changedTouches) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.screenX;
            if (zoomPos.scale === 1 && props.swiperHandler && typeof touchstartX === 'number' && typeof touchendX === 'number') {
                props.swiperHandler(touchstartX, touchendX);
            }
        }, className: classNames('gallery-wrapper', { scaling: zoomPos.scale > 1 }) },
        React.createElement("div", { className: "curator-carousel__zoom-control" },
            React.createElement("button", { className: "js-zoom-decrease-carousel carousel-curator-zoom-button--decrease", "aria-label": t('app.a11y.bag.decrease'), disabled: zoomPos.scale <= 1, onClick: zoomOut }),
            React.createElement("button", { className: "js-zoom-increase-carousel carousel-curator-zoom-button--increase", "aria-label": t('app.a11y.bag.increase'), disabled: zoomPos.scale >= 7, onClick: zoomIn }),
            React.createElement("div", { className: "js-close-carousel-curator" },
                React.createElement("button", { className: "close-carousel-curator-zoom", onClick: () => props.onCloseModal(), "aria-label": t('button.close') }))),
        React.createElement("div", { className: "js-curator-carousel__zoom" },
            React.createElement(PinchZoom, { ref: zoomRef, onUpdate: onUpdate, maxZoom: 7, minZoom: 0.2, onDragStart: () => setIsDragging(true), onDragEnd: () => setIsDragging(false) },
                React.createElement("div", { className: "curator-carousel-slide__img-holder zoom-img-wrapper", ref: imgRef },
                    React.createElement("img", { className: classNames('zoom-image-wrapper', { dragging: isDragging }), src: props.url, alt: "" }))),
            React.createElement("div", { className: "curator-carousel-slide__text-holder" },
                React.createElement("p", null, props.slideText)))));
};
export default CuratorCarouselSlideZoomModal;
